import { render, staticRenderFns } from "./Reminder.vue?vue&type=template&id=11bc8e4f&"
import script from "./Reminder.vue?vue&type=script&lang=ts&"
export * from "./Reminder.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports